import React from 'react';
import PropTypes from 'prop-types';
import { ScrollContainerV3 } from "../ScrollContainerV3";
import { AlignedGrid } from "../AlignedGrid";
import { GridMediaQueryBuilder, GridPresets } from "./components/GridMediaQueryBuilder";
import { gridOptionsShape } from "./components/GridMediaQueryBuilder/shapes";
import { GridContext } from "./context";
import { ScrollableGridItem } from "./ScrollableGridItem";

/**
 * Scrollable GRID DOES control the amount of children
 */
export var ScrollableGrid = function ScrollableGrid(_ref) {
  var children = _ref.children,
    count = _ref.count,
    options = _ref.options,
    levels = _ref.levels,
    className = _ref.className,
    gridClassName = _ref.gridClassName,
    isNoGrow = _ref.isNoGrow;
  return /*#__PURE__*/React.createElement(ScrollContainerV3, {
    className: className,
    isNoGrow: isNoGrow,
    "data-t-id": "common-ScrollableGrid"
  }, /*#__PURE__*/React.createElement(GridMediaQueryBuilder, {
    count: count !== null && count !== void 0 ? count : React.Children.count(children),
    name: "ovfCol",
    options: options,
    "data-t-id": "common-ScrollableGrid"
  }, function (queryClass) {
    return /*#__PURE__*/React.createElement(GridContext.Provider, {
      value: queryClass
    }, /*#__PURE__*/React.createElement(AlignedGrid, {
      className: gridClassName,
      isCarouselEnabled: options.hasCarousel,
      itemMaxSize: options.maxSize,
      levels: levels
    }, children));
  }));
};
ScrollableGrid.Item = ScrollableGridItem;
ScrollableGrid.propTypes = process.env.NODE_ENV !== "production" ? {
  options: PropTypes.shape(gridOptionsShape).isRequired,
  count: PropTypes.number,
  levels: PropTypes.number,
  children: PropTypes.node,
  className: PropTypes.string,
  gridClassName: PropTypes.string,
  isNoGrow: PropTypes.bool
} : {};
ScrollableGrid.presets = GridPresets;